export const FETCH_FIRST_BLOCK_NOTIFICATIONS = 'FETCH_FIRST_BLOCK_NOTIFICATIONS';
export const FETCH_SECOND_BLOCK_NOTIFICATIONS = 'FETCH_SECOND_BLOCK_NOTIFICATIONS';


// WEBPACK FOOTER //
// ./src/actions/notifications/types.js